// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import application from "./application";

import TransitionController from "./transition_controller";

import TransitionGroupController from "./transition_group_controller";
import NestedFormController from "./nested_form_controller";
import FlashController from "./flash_controller";
import CounterController from "./counter_controller";
import SustainableItemController from "./sustainable_item_controller";
import ItemSearchController from "./item_search_controller";
import TagComboboxController from "./tag_combobox_controller";
import SubmitFormController from "./submit_form_controller";
import ComboboxController from "./combobox_controller";
import ClipboardController from "./clipboard_controller";
import TurboFrameController from "./turbo_frame_controller";
import LocationAreaController from "./location_area_controller";
import PrintController from "./print_controller";
// import BasketController from "./basket_controller";

application.register("transition", TransitionController);
application.register("transition-group", TransitionGroupController);
application.register("nested-form", NestedFormController);
application.register("flash", FlashController);
application.register("counter", CounterController);
application.register("sustainable-item", SustainableItemController);
application.register("item-search", ItemSearchController);
application.register("tag-combobox", TagComboboxController);
application.register("submit-form", SubmitFormController);
application.register("combobox", ComboboxController);
application.register("clipboard", ClipboardController);
application.register("turbo-frame", TurboFrameController);
application.register("location-area", LocationAreaController);
application.register("print", PrintController);
// application.register("basket", BasketController);
